const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://athleteiq-9r76.onrender.com';
export default API_BASE_URL;